const awsConfig = {
    Auth: {
        Cognito: {
            userPoolId: process.env.REACT_APP_aws_user_pools_id as string,
            userPoolClientId: process.env.REACT_APP_aws_user_pools_web_client_id as string,
            identityPoolId: process.env.REACT_APP_aws_cognito_identity_pool_id as string,
            loginWith: {
                oauth: {
                    domain: process.env.REACT_APP_oauth_domain as string,
                    scopes: [
                        "phone",
                        "email",
                        "openid",
                        "profile",
                    ],
                    redirectSignIn: getRedirectUrls(),
                    redirectSignOut: getRedirectUrls(),
                    responseType: "code" as "code",
                    providers: ["Google"] as ("Google")[],
                },
            },
        },
    },
    Storage: {
        S3: {
            bucket: process.env.REACT_APP_aws_content_delivery_bucket as string,
            region: process.env.REACT_APP_aws_content_delivery_bucket_region as string,
        },
    },
};

function getRedirectUrls(): string[] {
    const prod = process.env.REACT_APP_CLIENT_URL || "https://app.rovlin.com";
    return ["http://localhost:3000", prod];
}

export default awsConfig;
